module.exports = "/assets/data/2980acdbaa4936bce3b5f9d0bdafbe9c-NR29.data.json";